import React, { useState, useEffect,useMemo } from 'react';
import Swal from 'sweetalert2'; // Import SweetAlert2
import axios from 'axios'; // Import axios
import { API_BASE_URL } from '../../api';
import Select from 'react-select';


const Add_Website = () => {
    const [formData, setFormData] = useState({
        client_id: '',
        websiteurl: '',
        domain_renewal_date: '',
        invoice_renewal_date: '',
        remarks: '',
        mail: '',
        server: '',
        status: 'live',
        created_by: localStorage.getItem('userId'),
        amount: '',
        renewal_amount: '',
    });

    const [clients, setClients] = useState([]);

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/api/client`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                        'Content-Type': 'application/json',
                    },
                });
                setClients(response.data);
            } catch (error) {
                console.error('Error fetching clients:', error.response?.data || error.message);
            }
        };

        fetchClients();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${API_BASE_URL}/api/website`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                    user_id: localStorage.getItem('userId'),
                },
            });

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Website added successfully!',
                confirmButtonText: 'OK',
                
            });
            setFormData({
                client_id: '',
                websiteurl: '',
                domain_renewal_date: '',
                invoice_renewal_date: '',
                remarks: '',
                mail: '',
                server: '',
                status: 'live',
                created_by: localStorage.getItem('userId'),
                amount:'',
                renewal_amount:''
            });
            window.location.reload();
        } catch (error) {
            console.error('Error adding website:', error.response?.data || error.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to add website. Please try again.',
                confirmButtonText: 'OK',
            });
        }
    };

      // 
      const clientOptions = useMemo(
        () =>
            clients.map((client) => ({
                value: client.id,
                label: client.full_name,
            })),
        [clients]
    );

    // Handler for react-select components
    const handleSelectChange = (selectedOption, actionMeta) => {
        setFormData((prevData) => ({
            ...prevData,
            [actionMeta.name]: selectedOption ? selectedOption.value : '',
        }));
    };

    // Handler for standard input fields
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    // Create selected option object for the client select
    const selectedClientOption = clientOptions.find(
        (option) => option.value === formData.client_id
    ) || null;


    return (
        <div className="modal fade" id="add_website">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Add Website</h4>
                        <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa fa-times"></i></button>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="modal-body text-start">
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <label className="form-label">Client Name</label>
                                    {clients.length === 0 ? (
                                        <p>Loading clients...</p>
                                    ) : (
                                        <Select
                                        options={clientOptions}
                                        name="client_id"
                                        value={selectedClientOption}
                                        onChange={handleSelectChange}
                                        placeholder="Select Client"
                                        classNamePrefix="select2"
                                    />
                                    )}
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Website Link</label>
                                    <input
                                        type="text"
                                        name="websiteurl"
                                        value={formData.websiteurl}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                    />
                                </div>
                                <div className="col-6 mb-3">
                                    <label className="form-label">Domain Renewal Date</label>
                                    <input
                                        type="date"
                                        name="domain_renewal_date"
                                        value={formData.domain_renewal_date}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                    />
                                </div>
                                <div className="col-6 mb-3">
                                    <label className="form-label">Invoice Renewal Date</label>
                                    <input
                                        type="date"
                                        name="invoice_renewal_date"
                                        value={formData.invoice_renewal_date}
                                        onChange={handleChange}
                                        className="form-control"
                                        required
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Remarks</label>
                                    <textarea
                                        name="remarks"
                                        value={formData.remarks}
                                        onChange={handleChange}
                                        className="form-control"
                                        rows="3"
                                    ></textarea>
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Email ID</label>
                                    <input
                                        type="text"
                                        name="mail"
                                        value={formData.mail}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                 
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Server</label>
                                    <input
                                        type="text"
                                        name="server"
                                        value={formData.server}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Amount</label>
                                    <input
                                        type="text"
                                        name="amount"
                                        value={formData.amount}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Renewal Amount</label>
                                    <input
                                        type="text"
                                        name="renewal_amount"
                                        value={formData.renewal_amount}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label className="form-label">Status</label>
                                    <select
                                        name="status"
                                        value={formData.status}
                                        onChange={handleChange}
                                        className="form-control"
                                    >
                                        <option value="live">Live</option>
                                        <option value="hold">Hold</option>
                                        <option value="inactive">Inactive</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light me-2"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Add Website
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Add_Website;
